<template>
  <SelectTableDialog
    :title="$t('businessReceiptList.btnList.createLogistics')"
    :searchColumns="searchColumns"
    :columnList="columnList"
    :defaultVisible="defaultVisible"
    :API="API"
    :extraData="extraData"
    :checkboxConfig="{ trigger: 'row' }"
    :confirmUnchecked="false"
    width="1200px"
    @dblclickEvent="dblclickEvent"
    @close="close"
    @confirm="confirm"
    @changeQuery="changeQuery"
  >
  </SelectTableDialog>
</template>

<script>
  import SelectTableDialog from '@/components/SelectTableDialog';
  import COMPANY_API from '@/api/masterData/company';
  import BUSINESS_API from '@/api/logisticsCenter/businessReceipt';
  export default {
    props: {
      inboundCompanyNo: {
        type: String,
        default: '',
      },
    },
    components: {
      SelectTableDialog,
    },
    data() {
      return {
        API: BUSINESS_API.LIST_DISTRIBUTION_INBOUND_DIALOG, // 物流入库列表
        defaultVisible: false,
        extraData: {
          // 查询有供应商发货指令的
          upstreamType: 1,
          inboundStatus: '02',
          isGetRemaind: 1,
        },
        query: {
          inboundDepartmentNo: null,
        },
      };
    },
    computed: {
      searchColumns() {
        const departmentUrl = this.inboundCompanyNo
          ? `${COMPANY_API.GET_COMPANY_DETAIL_API}/${this.inboundCompanyNo}`
          : '';
        return [
          {
            type: 'input',
            prop: 'inboundNo',
            name: this.$t('businessReceiptList.search.logisticsReceipt'),
          },
          {
            type: 'input',
            prop: 'shippingInstructionNo',
            name: this.$t('businessReceiptList.search.SupplierDelivery'),
          },
          {
            type: 'input',
            prop: 'purchaseContractNo',
            name: this.$t('businessReceiptList.search.purchaseContract'),
          },
          {
            type: 'input',
            prop: 'externalContractNo', // TODO 外部合同号
            name: this.$t('businessReceiptList.create.externalContractNo'),
          },
          {
            prop: 'productNo',
            name: this.$t('businessReceiptList.search.goods'),
            type: 'searchTableSpec',
            searchType: 'goodsDetail',
            isMultiple: true,
            getSearchCode: 'productDetailCode', // 搜索时获取商品列表里面的哪个值作为查询条件
          },
          {
            prop: 'salesmanNo', // 业务员
            name: this.$t('businessReceiptList.search.salesman'),
            type: 'searchTableSpec',
            searchType: 'personnel',
            isMultiple: true,
            getSearchCode: 'id',
          },
          {
            type: 'ajaxSelect',
            prop: 'inboundDepartmentNo',
            name: this.$t('businessReceiptList.search.department'),
            apiUrl: departmentUrl,
            clearable: true,
            method: 'get',
            dataString: 'data.department',
            valueKey: 'createDepartmentCode',
            labelKey: 'createDepartmentName',
          },
          {
            prop: 'partnerNo', // 供应商
            name: this.$t('businessReceiptList.search.supplier'),
            type: 'searchTableSpec',
            searchType: 'supplier',
            getSearchCode: 'partnerCode',
            extraData: {
              companyCode: this.inboundCompanyNo,
              departmentCode: this.query.inboundDepartmentNo,
            },
            isMultiple: true,
          },
          {
            prop: 'storageNo', // 仓库
            name: this.$t('businessReceiptList.search.warehouse'),
            type: 'searchTableSpec',
            searchType: 'warehouse',
            isMultiple: true,
            getSearchCode: 'storageCode',
          },
          {
            prop: 'remaindMoreThanZero',
            name: this.$t('businessReceiptList.create.remaindMoreThanZero'),
            type: 'checkbox',
            falseLable: 0,
            trueLable: 1,
            isChecked: false,
          },
        ];
      },
      columnList() {
        return [
          {
            prop: 'inboundNo',
            label: this.$t('businessReceiptList.search.logisticsReceipt'),
            width: 120,
            fixed: 'left',
          },
          {
            prop: 'shippingInstructionNo',
            label: this.$t('businessReceiptList.search.SupplierDelivery'),
            width: 120,
            fixed: 'left',
          },
          {
            prop: 'purchaseContractNo',
            label: this.$t('businessReceiptList.search.purchaseContract'),
            width: 120,
            fixed: 'left',
          },
          {
            prop: 'externalContractNo',
            label: this.$t('businessReceiptList.create.externalContractNo'),
            width: 120,
          },
          {
            prop: 'partnerName',
            label: this.$t('businessReceiptList.search.supplier'),
            width: 100,
          },
          {
            prop: 'productName',
            label: this.$t('businessReceiptList.table.commodityDescription'),
            width: 120,
          },
          {
            prop: 'inboundQuantity',
            label: this.$t('businessReceiptList.create.distributionInboundQuantity'),
            width: 140,
            format: 'formatQuality',
          },
          {
            prop: 'remainingBusinessInboundQuantity',
            label: this.$t('businessReceiptList.create.remainInboundQuantity'),
            width: 140,
            format: 'formatQuality',
          },
          { prop: 'unitNumber', label: this.$t('businessReceiptList.create.number'), width: 100 },
          {
            prop: 'inboundDate',
            label: this.$t('businessReceiptList.create.inboundDate'),
            width: 100,
          },
          {
            prop: 'storageName',
            label: this.$t('businessReceiptList.search.warehouse'),
            width: 100,
          },
          {
            prop: 'businessPropertyName',
            label: this.$t('businessReceiptList.create.managementWay'),
            width: 100,
          },
          {
            prop: 'salesmanName',
            label: this.$t('businessReceiptList.create.personName'),
            width: 100,
          },
          {
            prop: 'inboundCreatePersonName',
            label: this.$t('businessReceiptList.search.makingPeople'),
            width: 100,
          },
          {
            prop: 'inboundDepartmentName',
            label: this.$t('businessReceiptList.search.department'),
            width: 120,
          },
          { prop: 'companyName', label: this.$t('businessReceiptList.search.company'), width: 100 },
          { prop: 'createDate', label: this.$t('businessReceiptList.create.makeTime'), width: 100 },
        ];
      },
    },
    methods: {
      changeQuery(obj) {
        this.query.inboundDepartmentNo = obj.inboundDepartmentNo;
      },
      // 弹窗确认
      confirm(selections) {
        if (selections.length) {
          // 筛选相同的供应商发货指令号和仓库
          const shippingInstructionNo = selections[0].shippingInstructionNo;
          const storageNo = selections[0].storageNo;
          const hasNotSame = selections.some((item) => {
            return (
              item.shippingInstructionNo != shippingInstructionNo || item.storageNo != storageNo
            );
          });
          if (hasNotSame) {
            this.showTip(this.$t('businessReceiptList.errorTips.notSameShipNo'));
            return;
          }
          // 勾选不同的供应商发货指令号
          let inboundNoList = [];
          let purchaseContractNoList = [];
          selections.forEach((item) => {
            if (inboundNoList.indexOf(item.inboundNo) < 0) {
              inboundNoList.push(item.inboundNo);
            }
            if (purchaseContractNoList.indexOf(item.purchaseContractNo) < 0) {
              purchaseContractNoList.push(item.purchaseContractNo);
            }
          });
          const inboundNo = inboundNoList.join(',');
          const purchaseContractNo = purchaseContractNoList.join(',');
          // 进入业务入库单创建
          let path = {
            path: '/logistics/businessReceiptAdd',
            name: 'businessReceiptAdd',
            meta: {
              keepAlive: true,
              title: this.$t('businessReceiptList.create.tagTitle'),
            },
            query: {
              inboundNoList: inboundNo, // 物流入库单号，多个填充到一个框里
              shipNo: shippingInstructionNo, // 供应商发货指令号
              contractNo: purchaseContractNo, // 合同号
              sourceType: '2',
            },
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
          this.close();
        } else {
          // 未勾选
          this.showTip(this.$t('businessReceiptList.errorTips.inboundNoEmpty'));
        }
      },
      //双击选择
      dblclickEvent(selections) {
        let param = [selections.row];
        this.confirm(param);
      },
      showTip(tip) {
        this.$message({
          showClose: true,
          message: tip,
          type: 'error',
        });
      },
      // 弹窗关闭
      close() {
        this.defaultVisible = false;
      },
    },
  };
</script>
